import React from 'react'

import { PalantirTextField } from '../../../components/input/Text'


const Summary = React.memo(function(props) {
        
    return (
        <div className="notes field-group" style={{marginTop: "30px"}}>
            <PalantirTextField
                label="Summary"
                value={props.plantSummary}
                fullWidth
                multiline
                variant="filled"
                rows={5}
                onChange={(x) => props.updatePlant(x)}
            />
        </div>
    )
}, (prevProps, nextProps) => {
    return (
        prevProps.plantSummary===nextProps.plantSummary
    )
})
export default Summary